// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b41cc2d3","396":"2761bd84","455":"0bf60353","977":"1901cd06"}[chunkId] + ".chunk.js";
};